import { render, staticRenderFns } from "./CreateNewCart.vue?vue&type=template&id=098526a6&"
import script from "./CreateNewCart.vue?vue&type=script&lang=js&"
export * from "./CreateNewCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports